module.exports = {
    // publicPath: process.env.NODE_ENV === 'production' ? './' : '/',
    publicPath: '/',
    devServer: {
        proxy: {
            '/api': {
                // target: 'http://cc.qk0.cc:9010',
                // target: 'http://cc.qk0.cc:9000',
                // target: 'http://127.0.0.1:8005', // 本地测试
                target: 'http://cc.qk0.cc:8005', // sjh面向因特睿开的后端
                changeOrigin: true,             //是否跨域
                ws: true,                       //是否代理 websockets
                secure: true,                   //是否https接口
                pathRewrite: {                  //路径重置
                    '^/api': ''
                }
            },
            '/modelopsapi': {
                target: 'http://cc.qk0.cc:8001',
                changeOrigin: true,             //是否跨域
                ws: true,                       //是否代理 websockets
                secure: true,                   //是否https接口
                pathRewrite: {                  //路径重置
                    '^/modelopsapi': ''
                }
            }
            
        }
    }
};
